import {
  createStaffCopilotApi,
  type StaffCopilotRunOptions,
  type StaffCopilotRunResult,
} from "@lafayette/api-client";
import type { StaffCopilotRunBody, StaffCopilotSession } from "@lafayette/schemas";

import type { ConversationsCallOptions } from "../conversations/api";

// The API of the private Staff Copilot as the admin sees it (CHT-733). ONE small interface, so the pane never knows which client sits behind
// it and a test swaps in a fake (`test/fake-copilot-api.ts`). It takes a conversation id and a question and nothing else: no channel, no
// customer, no staff user id. The failures are the errors of the api-client package, so the
// pane describes them with `classifyFailure`, like every other pane.

export type CopilotRunOptions = ConversationsCallOptions &
  Pick<StaffCopilotRunOptions, "idempotencyKey" | "onUpdate">;

export interface CopilotApi {
  /** MC-E3. The private channel of the caller for this conversation (the history of the pane is read from it). */
  getSession(
    conversationId: string,
    options?: ConversationsCallOptions,
  ): Promise<StaffCopilotSession>;
  /** MC-E4. One question, one answer. */
  run(
    conversationId: string,
    body: StaffCopilotRunBody,
    options?: CopilotRunOptions,
  ): Promise<StaffCopilotRunResult>;
}

export type HttpCopilotApiOptions = Readonly<{
  baseUrl: string;
  getAccessToken: () => string | null | undefined | Promise<string | null | undefined>;
  fetch?: typeof globalThis.fetch;
}>;

export function createHttpCopilotApi(options: HttpCopilotApiOptions): CopilotApi {
  const client = createStaffCopilotApi(options);
  return {
    getSession: (conversationId, callOptions) => client.getSession(conversationId, callOptions),
    run: (conversationId, body, callOptions) => client.run(conversationId, body, callOptions),
  };
}
